import { cdnLink } from "@/config";

export default {
  3: {
    name: 'ptfl',
    background: `${cdnLink}/act-plan/ptfl/1.png`,
    title: `${cdnLink}/act-plan/ptfl/2.png`,
    close: `${cdnLink}/act-plan/ptfl/3.png`,
    classify: ``,
    classifySelected: `${cdnLink}/act-plan/ptfl/5.png`,
    act: `${cdnLink}/act-plan/ptfl/4.png`,
    actSelected: `${cdnLink}/act-plan/ptfl/6.png`,
    actColor: 'C0A263',
    redPoint: `${cdnLink}/act-plan/ptfl/7.png`,
    specialFont: true,
  },
  4: {
    name: 'fgcq',
    background: `${cdnLink}/act-plan/fgcq/1.png`,
    title: `${cdnLink}/act-plan/fgcq/2.png`,
    close: `${cdnLink}/act-plan/fgcq/3.png`,
    classify: ``,
    classifySelected: `${cdnLink}/act-plan/fgcq/5.png`,
    act: `${cdnLink}/act-plan/fgcq/4.png?v=2`,
    actSelected: `${cdnLink}/act-plan/fgcq/6.png?v=2`,
    actColor: 'C0A263',
    redPoint: `${cdnLink}/act-plan/fgcq/7.png`,
    closeStyle: { 
      position: 'absolute',
      top: '16px',
      right: '23px',
      width: '13px',
      height: 'auto'
    },
    activeClassifyStyle: {
      paddingBottom: '7px',
    },
    classifyStyle: {
      paddingBottom: '7px',
    },
    actBackStyle: {
      width:  '380px',
      left: '123px',
      height: '226px'
    },
    specialFont: true,
  },
  5: {
    name: 'kxcq',
    background: `${cdnLink}/act-plan/kxcq/1.png`,
    title: `${cdnLink}/act-plan/kxcq/2.png`,
    close: `${cdnLink}/act-plan/kxcq/3.png`,
    classify: ``,
    classifySelected: `${cdnLink}/act-plan/kxcq/5.png`,
    act: `${cdnLink}/act-plan/kxcq/4.png`,
    actSelected: `${cdnLink}/act-plan/kxcq/6.png`,
    actColor: 'C0A263',
    redPoint: `${cdnLink}/act-plan/kxcq/7.png`,
    specialFont: true,
    actBackStyle: {
      width:  '385px',
      left: '123px',
      height: '222px'
    }
  },
  6: {
    name: 'xx',
    background: `${cdnLink}/act-plan/xx/1.png?v=4`,
    title: `${cdnLink}/act-plan/xx/2.png`,
    close: `${cdnLink}/act-plan/xx/3.png`,
    classify: ``,
    classifySelected: `${cdnLink}/act-plan/xx/5.png`,
    act: `${cdnLink}/act-plan/xx/4.png`,
    actSelected: `${cdnLink}/act-plan/xx/6.png`,
    actColor: 'C0A263',
    redPoint: `${cdnLink}/act-plan/xx/7.png`,
    classifyWrapStyle: {
      marginTop: '22px'
    },
    titleIconStyle: {
      left: '34px',
      top: '28px',
      width: '90px'
    },
    // activityUlStyle: {
    //   left: '34px',
    //   width: '90px',
    //   height: 'calc(100% - 78px)'
    // },
    // pActivityUlStyle: {
    //   left: '22px',
    //   width: '96px',
    //   height: 'calc(100% - 74px)'
    // },
    actBackStyle: {
      width:  '385px',
      left: '123px',
      height: '222px'
    }
  },
  7: {
    name: 'gq',
    background: `${cdnLink}/act-plan/gq/1.png`,
    title: `${cdnLink}/act-plan/gq/2.png`,
    close: `${cdnLink}/act-plan/gq/3.png`,
    classify: ``,
    classifySelected: `${cdnLink}/act-plan/gq/5.png`,
    act: `${cdnLink}/act-plan/gq/4.png?v=2`,
    actSelected: `${cdnLink}/act-plan/gq/6.png?v=2`,
    actColor: 'C0A263',
    redPoint: `${cdnLink}/act-plan/fgcq/7.png`,
    closeStyle: { 
      position: 'absolute',
      top: '28px',
      right: '-10px',
      width: '43px',
      height: 'auto'
    },
    actBackStyle: {
      width:  '405px',
      left: '116px',
      height: '222px'
    },
    specialFont: true,
  },
}